import GameEnd from "./GameEnd";
export default GameEnd;
